"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = Heading;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

require("./styles/Heading.module.scss");

var styles = {
  "heading": "Heading-module__heading___1VA_G",
  "heading1": "Heading-module__heading1___10k5j Heading-module__heading___1VA_G",
  "heading2": "Heading-module__heading2___3dCRC Heading-module__heading___1VA_G",
  "heading3": "Heading-module__heading3___KWRPA Heading-module__heading___1VA_G",
  "heading4": "Heading-module__heading4___226ho Heading-module__heading___1VA_G",
  "heading5": "Heading-module__heading5___2SYTC Heading-module__heading___1VA_G",
  "thin": "Heading-module__thin___3TiUD",
  "regular": "Heading-module__regular___2BslH",
  "strong": "Heading-module__strong___TB2no",
  "left": "Heading-module__left___DWiGp",
  "center": "Heading-module__center___3QXKn",
  "right": "Heading-module__right___1HIX6",
  "justify": "Heading-module__justify___9Oijk",
  "uppercase": "Heading-module__uppercase___xCo0B",
  "lightColored": "Heading-module__lightColored___mIS1Y"
};

var cn = _bind.default.bind(styles);

function Heading(IHeading) {
  return _react.default.createElement("div", null, "This doesn't render. Use Heading.H1, .H2, H3 etc..");
}

Heading.H1 = function (_ref) {
  var _cn;

  var children = _ref.children,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 'strong' : _ref$weight,
      uppercase = _ref.uppercase,
      lightColored = _ref.lightColored,
      className = _ref.className,
      align = _ref.align;
  return _react.default.createElement("h1", {
    className: cn((_cn = {
      heading1: true
    }, _defineProperty(_cn, weight, Boolean(weight)), _defineProperty(_cn, "uppercase", uppercase), _defineProperty(_cn, align, Boolean(align)), _defineProperty(_cn, "lightColored", lightColored), _cn), className)
  }, children);
};

Heading.H2 = function (_ref2) {
  var _cn2;

  var children = _ref2.children,
      _ref2$weight = _ref2.weight,
      weight = _ref2$weight === void 0 ? 'strong' : _ref2$weight,
      uppercase = _ref2.uppercase,
      lightColored = _ref2.lightColored,
      className = _ref2.className,
      align = _ref2.align;
  return _react.default.createElement("h2", {
    className: cn((_cn2 = {
      heading2: true
    }, _defineProperty(_cn2, weight, Boolean(weight)), _defineProperty(_cn2, "uppercase", uppercase), _defineProperty(_cn2, align, Boolean(align)), _defineProperty(_cn2, "lightColored", lightColored), _cn2), className)
  }, children);
};

Heading.H3 = function (_ref3) {
  var _cn3;

  var children = _ref3.children,
      _ref3$weight = _ref3.weight,
      weight = _ref3$weight === void 0 ? 'regular' : _ref3$weight,
      uppercase = _ref3.uppercase,
      lightColored = _ref3.lightColored,
      className = _ref3.className,
      align = _ref3.align;
  return _react.default.createElement("h3", {
    className: cn((_cn3 = {
      heading3: true
    }, _defineProperty(_cn3, weight, Boolean(weight)), _defineProperty(_cn3, "uppercase", uppercase), _defineProperty(_cn3, align, Boolean(align)), _defineProperty(_cn3, "lightColored", lightColored), _cn3), className)
  }, children);
};

Heading.H4 = function (_ref4) {
  var _cn4;

  var children = _ref4.children,
      _ref4$weight = _ref4.weight,
      weight = _ref4$weight === void 0 ? 'strong' : _ref4$weight,
      uppercase = _ref4.uppercase,
      lightColored = _ref4.lightColored,
      className = _ref4.className,
      align = _ref4.align;
  return _react.default.createElement("h4", {
    className: cn((_cn4 = {
      heading4: true
    }, _defineProperty(_cn4, weight, Boolean(weight)), _defineProperty(_cn4, "uppercase", uppercase), _defineProperty(_cn4, align, Boolean(align)), _defineProperty(_cn4, "lightColored", lightColored), _cn4), className)
  }, children);
};

Heading.H5 = function (_ref5) {
  var _cn5;

  var children = _ref5.children,
      _ref5$weight = _ref5.weight,
      weight = _ref5$weight === void 0 ? 'strong' : _ref5$weight,
      _ref5$uppercase = _ref5.uppercase,
      uppercase = _ref5$uppercase === void 0 ? true : _ref5$uppercase,
      lightColored = _ref5.lightColored,
      className = _ref5.className,
      align = _ref5.align;
  return _react.default.createElement("h5", {
    className: cn((_cn5 = {
      heading5: true
    }, _defineProperty(_cn5, weight, Boolean(weight)), _defineProperty(_cn5, "uppercase", uppercase), _defineProperty(_cn5, align, Boolean(align)), _defineProperty(_cn5, "lightColored", lightColored), _cn5), className)
  }, children);
};